<script setup lang="ts">
import { useFetch } from '@vueuse/core'
import { onMounted } from 'vue-demi'

interface NotificationProviderProps {
  getAuthTokenFn?: () => Promise<string>
}

const props = defineProps<NotificationProviderProps>()

/* eslint-disable no-console, arrow-parens */
onMounted(() => {
  fetch('https://jsonplaceholder.typicode.com/posts/1')
    .then((response) => response.json())
    .then((json) => console.log('fetch', json))

  const data = useFetch('https://jsonplaceholder.typicode.com/posts/1')
  console.log('useFetch', data)

  if (props.getAuthTokenFn)
    console.log('Auth token', props.getAuthTokenFn())
})
</script>

<template>
  <div>Notification Provider</div>
</template>

<style scoped lang="scss">
</style>
